import DepositLimit from './DepositLimit';

export default DepositLimit;
